/* Landing-page sign-in (bundled to landing.js): the same Firebase auth as the
   editor, so signing in here signs you in everywhere on the site. After a
   successful sign-in we head straight into the editor. */
import { cloudReady, initCloud, onAuth, signOut } from './cloud.ts';
import { showSignIn } from './authui.ts';

const btn = document.getElementById('signinBtn') as HTMLElement | null;
const modal = document.getElementById('authModal') as HTMLElement | null;

if (btn && modal) {
  let user: { displayName?: string | null; email?: string | null } | null = null;
  initCloud().then(ok => {
    if (!ok) { btn.style.display = 'none'; return; }
    onAuth(raw => {
      const u = raw && !raw.isAnonymous ? raw : null;   // headset-pairing anon session ≠ account
      user = u;
      btn.textContent = u ? (u.displayName || u.email || 'Account') : 'Sign in';
      btn.title = u ? 'Signed in — your layouts sync to this account. Click to sign out.'
                    : 'Sign in to sync your layouts across devices';
    });
  });
  // in-app confirm (no window.confirm anywhere in the app)
  const confirmBox = (msg: string, ok: string): Promise<boolean> => new Promise(resolve => {
    const modal = document.getElementById('cModal')!, okBtn = document.getElementById('cOk')!, cancelBtn = document.getElementById('cCancel')!;
    document.getElementById('cMsg')!.textContent = msg;
    okBtn.textContent = ok;
    modal.classList.add('show');
    const done = (v: boolean) => { modal.classList.remove('show'); okBtn.removeEventListener('click', yes); cancelBtn.removeEventListener('click', no); resolve(v); };
    const yes = () => done(true), no = () => done(false);
    okBtn.addEventListener('click', yes);
    cancelBtn.addEventListener('click', no);
  });
  btn.addEventListener('click', async e => {
    e.preventDefault();
    if (!cloudReady()) return;
    if (user) {
      if (await confirmBox('Sign out? Your layouts stay in your account.', 'Sign out')) signOut();
    } else {
      modal.classList.add('show');
      showSignIn(document.getElementById('fbui')!, () => { location.href = '/edit'; });
    }
  });
  document.getElementById('authCancel')!.addEventListener('click', () => modal.classList.remove('show'));
  modal.addEventListener('click', e => { if (e.target === modal) modal.classList.remove('show'); });
}
